import { render } from "./OpenIndicator.vue?vue&type=template&id=7e05f866"
const script = {}

import exportComponent from "/home/runner/work/vue-select/vue-select/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__